<script>
  import { onMount } from "svelte";
  import { ModalBody, ModalFooter, ModalHeader, Modal } from "sveltestrap";
  import backend from "../../../../../server";
  import moment from "moment";
  import Paginator from "./../../../../components/Pagination.svelte";
    import { paramsUser, paramsClients } from "./stores.js";
   

   export let isSelectPlayer;
   export let configBonnus;
   export let onSave; 

    let clients = [];
    let isLoadingClient = false;
    let messageClient = null;

    let users = [];
    let isLoadingUsers = false;
    let messageUser = null;
  

    let selectedClient = configBonnus.client;
    let selectedPlayers = configBonnus.players ?? [];


  const closed = () => (isSelectPlayer = !isSelectPlayer);
  function playesSave() {
    const updatedConfig = {
      ...configBonnus,
      client: selectedClient,
      players: selectedPlayers,
    };
    onSave && onSave(updatedConfig);
  }

  //||||||   CLIENTS  ||||||||
  const clearSearchClients =()=> {
      paramsClients.update((c) => ({ ...c, searching: "", search: "", page: 1 }));
      getclients();
    }
    const searchClient =()=> {
      getclients();
      clearFieldUser('clientcode') //reset user filter
    }
    const changePageClientes =(newPage)=> {
      paramsClients.update((c) => ({ ...c, page: newPage }));
      getclients();
    }
    const selectdClient=(id) =>{
      const foundClient = clients.find(c => c.id === id);
      if (foundClient) {
        selectedClient=foundClient;
      paramsUser.update(p => ({ ...p, clientcode: foundClient.code }));
      getUsers();
    }
    }
    $: clientsFiltrados = clients.filter((c) =>
      (c.code || "").toLowerCase().includes($paramsClients.search.toLowerCase())
    );
   
   

    //|||||| PLAYERS ||||||||||
    $: usersFiltered = users.filter((user) =>
      (user.username_origin || "").toLowerCase().includes(($paramsUser.search || "").toLowerCase())
    );
    if (selectedClient && selectedClient?.id) {
      paramsUser.update(p => ({ ...p, clientcode: selectedClient?.code }));
      getUsers();
    }
  
    const searUsers=()=> {
      getUsers();
    }
    const fieldsToUsers = ['searching','clientcode'];
    const clearFieldUser=(field)=> {
      paramsUser.update(u => {
        u[field] = '';
        u.page = 1; 
        return u;
      });
      selectedClient=null;
      getUsers();
    }

    const selectUserRow = (user) => {
 
  if (selectedPlayers.some((u) => u.username === user.username)) {
    selectedPlayers = selectedPlayers.filter((u) => u.username !== user.username);
  } else {
    selectedPlayers = [...selectedPlayers, user];
  }
};


    const changePageUsers = (newPage) =>{
      paramsUser.update((p) => ({ ...p, page: newPage }));
      getUsers();
    }

    onMount(() => {
      getclients();
    });
  

  async function getclients() {
    try {
      isLoadingClient = true;
      messageClient = null;
      const $c = $paramsClients;
      let response = await backend.client.lists($c);
      let { data } = response;
      clients = data.list || [];
      paramsClients.update((c) => ({
        ...c,
        total: Number(data.total),
        page: Number(data.page),
        xpage: Number(data.xpage),
        searching: c.search || c.searching,
        search: "",
      }));
      if (!clients.some((c) => c.id === selectedClient?.id)) {
        selectedClient = null;
      }
    } catch (e) {
      messageClient = `Error al cargar clients: ${e.message}. Por favor, intente de nuevo.`;
    } finally {
      isLoadingClient = false;
    }
  }
  async function getUsers() {
      try {
        isLoadingUsers = true;
        messageUser = null;
        const $p = $paramsUser;
        let response = await backend.users.list($p);
        let { data } = response;
        users = data.list || [];
        paramsUser.update((p) => ({
          ...p,
          total: Number(data.total),
          page: Number(data.page),
          xpage: Number(data.xpage),
          searching: p.search || p.searching,
          search: "",
        }));
      } catch (e) {
        messageUser = `Error al cargar users: ${e.message}. Por favor, intente de nuevo.`;
      } finally {
        isLoadingUsers = false;
      }
    }
</script>

<Modal isOpen={isSelectPlayer} toggle={closed} size="xl">
  <ModalHeader toggle={closed}>Seleccione jugadores:</ModalHeader>
  <ModalBody>
    <!-- Div con dos columnas -->
    <div class="row gx-3 mt-4">
      <div class="col-md-6 border">
        <h5>Sección Clientes</h5>
        <div
          class="input-group"
          style="display: flex; gap: 8px; align-items: center;margin: 2px"
        >
          <input
            type="search"
            class="form-control"
            placeholder="Search client"
            bind:value={$paramsClients.search}
            on:keydown={(e) => e.key === "Enter" && searchClient()}
          />
          {#if $paramsClients.search.trim() !== "" || clientsFiltrados.length === 0}
            <button  type="button"
              class="btn btn-outline-secondary"
              on:click={searchClient}
            >
              <i class="fa-solid fa-magnifying-glass"></i>
            </button>
          {/if}
        </div>
        {#if $paramsClients.searching !== ""}
          <span>Buscando: </span>
          <div class="toast-pill mt-2 d-inline-flex align-items-center bg-dark text-white rounded-pill px-2 py-0 gap-1 mt-2" style="font-size: 14px;" >
            <span>{$paramsClients.searching}</span>
            <button
              type="button"
              class="btn-close btn-close-white btn-sm"
              aria-label="Cerrar"
              on:click={clearSearchClients}
            ></button>
          </div>
        {/if}

        {#if isLoadingClient}
          <div style="padding: 6px; text-align: center;">
            Loading clients...
          </div>
        {:else if messageClient}
          <div style="padding: 6px; color: red; text-align: center;">
            {messageClient}
          </div>
        {:else if clientsFiltrados.length === 0}
          <div style="padding: 6px; color: #888; text-align: center;">
            No hay clients en la página actual. Usa la búsqueda. 🔍
          </div>
        {:else}
          <!-- Aquí envuelvo los items para scroll -->
          <div
            style="max-height: 25em; overflow-y: auto; border: 1px solid #ddd; border-radius: 4px; padding: 4px;"
          >
            {#each clientsFiltrados as cliente}
              <label
                style="display: block; padding: 6px 8px; border-bottom: 1px solid #eee; cursor: pointer;"
              >
                <input
                  type="radio"
                  name="cliente"
                  value={cliente.id}
                  checked={selectedClient?.id === cliente.id}
                  on:change={() => selectdClient(cliente.id)}
                  style="margin-right: 8px;"
                />
                {cliente.code}
              </label>
            {/each}
          </div>
        {/if} 
        <div
          style="margin-top: 8px; text-align: center; max-width: 100%; word-wrap: break-word;"
        >
          <Paginator
            current={$paramsClients.page}
            total={$paramsClients.total}
            xpage={$paramsClients.xpage}
            onPageClick={changePageClientes}
          />
        </div>
      </div>
      <div class="col-md-6 border">
        <h5>Sección Players</h5>
        
<!-- Usuarios: Input búsqueda -->
<div
class="input-group"
style="display: flex; gap: 8px; align-items: center;"
>
<input
  type="search"
  placeholder="Buscar usuario"
  class="form-control"
  style="flex: 1;"
  bind:value={$paramsUser.search}
  on:keydown={(e) => e.key === "Enter" && searUsers()}
/>
{#if $paramsUser.search.trim() !== "" || usersFiltered.length === 0}
  <button
    type="button"
    class="btn btn-outline-secondary"
    on:click={searUsers}
  >
    <i class="fa-solid fa-magnifying-glass"></i>
  </button>
{/if}
</div>

{#each fieldsToUsers as field}
{#if $paramsUser[field]?.trim() !== ''}
<div class="toast-pill mt-2 d-inline-flex align-items-center bg-dark text-white rounded-pill px-2 py-0 gap-1 mt-2" style="font-size: 14px;">
  <span>{field.charAt(0).toUpperCase() + field.slice(1)}: {$paramsUser[field]}</span>
  <button
    type="button"
    class="btn-close btn-close-white btn-sm"
    aria-label="Cerrar"
    on:click={() => clearFieldUser(field)}
  ></button>
</div>
{/if}
{/each}

<!-- Tabla hija con clase "table" y footer vacío -->
<div
style="max-height: 25em; 1px solid #ddd; overflow-y: auto; width: 100%;"
>
<table
  class="table table-scroll"
  style="border-collapse: collapse; width: 100%;"
>
  <thead>
    <tr>
      <th>N°</th>
      <th>Usuario</th>
      <th>Moneda</th>
      <th style="text-align: center;">Selected</th>
    </tr>
  </thead>
  <tbody>
    {#if isLoadingUsers}
      <tr
        ><td colspan="4" style="text-align: center;"
          >Cargando users...</td
        ></tr
      >
    {:else if messageUser}
      <tr
        ><td
          colspan="4"
          style="color: red; text-align: center;"
          >{messageUser}</td
        ></tr
      >
    {:else if usersFiltered.length === 0}
      <tr
        ><td colspan="4" style=" color: #888; text-align: center;"
          >No hay users en la página actual. Usa el buscar 🔍</td
        ></tr
      >
    {:else}
      <!-- iterador -->
      {#each usersFiltered as user, index}
  <tr
    on:click={() => selectUserRow(user)}
    class:selected={selectedPlayers.some(u => u.username === user.username)}
    style="cursor: pointer;"
  >
    <td>{($paramsUser.page - 1) * $paramsUser.xpage + index + 1}</td>
    <td>{user.firstname} {user.lastname} - {user.username_origin}</td>
    <td>{user.currency}</td>
    <td style="text-align: center;">
      {#if selectedPlayers.some(u => u.username === user.username)}✔️{/if}
    </td>
  </tr>
{/each}

    {/if}
  </tbody>
</table>
</div>
<Paginator
current={$paramsUser.page}
total={$paramsUser.total}
xpage={$paramsUser.xpage}
onPageClick={changePageUsers}
/>

      </div>
    </div>
  </ModalBody>
  <ModalFooter>
    <button class="btn btn-outline-primary" on:click={() => playesSave()}>
      extraer
    </button>
  </ModalFooter>
</Modal>

<style>
</style>
